// Dependencies
import React from 'react';
import _ from 'lodash';
import Api from '../api'
import { Helpers, Config, defaults } from '../utils';

// Types
import { Containers, Types } from '../types';
import useEventBus from '../hooks/useEventBus';
import Minicart from './Minicart';

const initialState: any = {
    loading: true,
    errors: {},
    data: {
        items: {},
        cart: {
            subtotal: 0
        }
    },
    ...defaults
}

const App = () => {
    
    // NOTE: Handles data fetching only (both from internal and external sources)
    const [store, updateStore] = React.useState<any>(initialState);
    const eventBus = useEventBus();

    const setState = (key: string, value: any) => {
        if (!(key in initialState)) {
            throw Error(`Key ${key} is not valid state.`);
        }
        updateStore((prevStore: any) => ({ ...prevStore, [key]: value instanceof Function ? value(prevStore[key]) : value, }))
    }

    const loadInternalData = async () => {

        const data = {     
            ...Config.REACT_APP_DATA
        }

        updateStore((prevState: any) => _.merge(defaults, prevState, data));
    }

    const loadExternalData = async () => {
        setState('loading', true);

        try {
            const response = await Api.getCart();

            if ( _.isEmpty(response?.errors) ) {
                updateStore((prevState: any) => _.merge(defaults, prevState, response));
                setState('loading', false);
            }
        } catch (e) {
            console.log(e);
        }
         
    }

    const handleProductAddToCart = async ({id, type, selected, quantity}: any) => {

        setState('loading', true);

        // NOTE: Assign reccursion limit
        // TOOD: Validate/state canAddToCart
        let response;
        try {
            response = await Api.addProductToCart(id, {
                quantity,
                type,
                selected
            });
            if ( _.isEmpty(response?.errors) ) {
                eventBus.dispatch('cartContentsUpdated', {...response})
            }
            setState('loading', false);
        } catch (e) {
            console.log(e);
        }

    }

    React.useEffect(() => {
        loadInternalData();
        loadExternalData();

        eventBus.on('addProductToCart', (props: any) => {   
            console.log(props);
            handleProductAddToCart(props)
        });

        eventBus.on('cartContentsUpdated', (props: any) => {   
            if ( _.isEmpty(props?.errors) ) {
                setState('data', props.data);
            }
        });

        return () => eventBus.remove('cartContentsUpdated');

    }, []);

    // TODO: This will be actually the main App component handling data fetching

    return <Minicart {...store} />
    
}

export default App;
